// extracted by mini-css-extract-plugin
module.exports = {"column_search":"ColumnConfig__column_search___zgnVJ","range_input":"ColumnConfig__range_input___1vmCi"};